(function () {
  const config = window.buildYourBundle?.config;
  if (!config?.sectionId) return;

  const section = document.getElementById('build-your-bundle-' + config.sectionId);
  if (!section) return;

  const bundleTiers = config.bundleTiers || [
    { min: 3, max: 5, discount: 5 },
    { min: 6, max: 8, discount: 10 },
    { min: 9, max: 999, discount: 15 }
  ];
  let currentTierIndex = bundleTiers.length - 1;
  let bundle = []; // array of { variantId, productId, price, title, imageUrl, variantTitle }

  const STORAGE_KEY = 'byob_bundle_' + (config.sectionId || 'main');
  const STORAGE_SYNC_KEY = 'byob_cart_synced_' + (config.sectionId || 'main');
  let cartSyncedSignature = null;
  var byobCartMutationPending = false;
  var byobSidebarClearedAt = 0;
  var BYOB_LOG_PREFIX = '[BYOB]';
  var BYOB_REMOVE_ICON_HTML =
    '<span class="svg-wrapper" aria-hidden="true">' +
    '<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-cart-drawer-remove" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">' +
    '<path d="M2 4.00065H14M12.6667 4.00065V13.334C12.6667 14.0007 12 14.6673 11.3333 14.6673H4.66667C4 14.6673 3.33333 14.0007 3.33333 13.334V4.00065M5.33333 4.00065V2.66732C5.33333 2.00065 6 1.33398 6.66667 1.33398H9.33333C10 1.33398 10.6667 2.00065 10.6667 2.66732V4.00065M6.66667 7.33398V11.334M9.33333 7.33398V11.334" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg></span>';

  function byobLog() {
    if (typeof console !== 'undefined' && console.log) {
      var args = [BYOB_LOG_PREFIX].concat(Array.prototype.slice.call(arguments));
      console.log.apply(console, args);
    }
  }

  function logCartDiscountState() {
    var cartUrl = (config.cartUrl || '/cart').toString().replace(/\/$/, '');
    if (cartUrl.indexOf('.js') === -1) cartUrl = cartUrl + '.js';
    fetch(cartUrl, { method: 'GET', headers: { 'Accept': 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var apps = (cart && cart.cart_level_discount_applications) ? cart.cart_level_discount_applications : [];
        byobLog('Cart discount state', {
          total_discount: cart.total_discount,
          total_price: cart.total_price,
          discount_codes_count: (cart.discount_codes && cart.discount_codes.length) || 0,
          discount_codes: (cart.discount_codes && cart.discount_codes.length) ? cart.discount_codes.map(function (d) { return d.code; }) : [],
          cart_level_discount_applications: apps.length,
          applications: apps.map(function (a) { return { title: a.title, value: a.value, total_allocated: a.total_allocated_amount }; })
        });
      })
      .catch(function (err) {
        byobLog('Failed to fetch cart for discount state', err);
      });
  }

  function loadBundleFromStorage() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (raw) {
        var parsed = JSON.parse(raw);
        if (Array.isArray(parsed) && parsed.length) return parsed;
      }
    } catch (e) {}
    return [];
  }

  function productRequiresLoa(productId) {
    if (!productId) return false;
    var loaCard = section.querySelector('.byob-card[data-product-id="' + productId + '"]');
    return !!(loaCard && loaCard.getAttribute('data-requires-loa') === 'true');
  }

  function productIsRegularPrice(productId) {
    if (!productId) return false;
    var card = section.querySelector('.byob-card[data-product-id="' + productId + '"][data-regular-price="true"]');
    return !!card;
  }

  function rehydrateBundleLoaFlags(items) {
    if (!Array.isArray(items)) return [];
    return items.map(function (item) {
      var next = Object.assign({}, item);
      next.requiresLoa = !!(item && item.requiresLoa) || productRequiresLoa(item && item.productId);
      next.isRegularPrice = !!(item && item.isRegularPrice) || productIsRegularPrice(item && item.productId);
      return next;
    });
  }

  function saveBundleToStorage() {
    try {
      if (bundle.length) sessionStorage.setItem(STORAGE_KEY, JSON.stringify(bundle));
      else {
        sessionStorage.removeItem(STORAGE_KEY);
        invalidateCartSync();
      }
    } catch (e) {}
  }

  // Single source of truth for BYOB selection (updated before any cart API)
  window.BYOB_STATE = window.BYOB_STATE || { selectedCount: 0, selectedVariantIds: [] };

  function syncByobStateAndEmit() {
    window.BYOB_STATE.selectedCount = bundle.length;
    window.BYOB_STATE.selectedVariantIds = bundle.map(function (item) { return String(item.variantId); });
    updateAddToCartButtonState();
    document.dispatchEvent(new CustomEvent('byob:changed', {
      detail: {
        selectedCount: window.BYOB_STATE.selectedCount,
        selectedVariantIds: window.BYOB_STATE.selectedVariantIds.slice()
      }
    }));
  }

  function getBundleSignature(items) {
    var counts = {};
    items.forEach(function (item) {
      var id = String(item.variantId);
      counts[id] = (counts[id] || 0) + 1;
    });
    return Object.keys(counts).sort().map(function (id) {
      return id + ':' + counts[id];
    }).join('|');
  }

  function loadCartSyncFromStorage() {
    try {
      cartSyncedSignature = sessionStorage.getItem(STORAGE_SYNC_KEY) || null;
    } catch (e) {
      cartSyncedSignature = null;
    }
  }

  function invalidateCartSync() {
    cartSyncedSignature = null;
    try {
      sessionStorage.removeItem(STORAGE_SYNC_KEY);
    } catch (e) {}
  }

  function markBundleSyncedWithCart() {
    cartSyncedSignature = getBundleSignature(bundle);
    try {
      if (cartSyncedSignature) sessionStorage.setItem(STORAGE_SYNC_KEY, cartSyncedSignature);
      else sessionStorage.removeItem(STORAGE_SYNC_KEY);
    } catch (e) {}
    updateAddToCartButtonState();
  }

  function isBundleSyncedWithCart() {
    if (!cartSyncedSignature || bundle.length < getMinBundleItems()) return false;
    return getBundleSignature(bundle) === cartSyncedSignature;
  }

  function openCartDrawer(done) {
    done = typeof done === 'function' ? done : function () {};
    byobLog('Opening cart drawer');
    try {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } catch (err) {}
    var cartDrawer = document.querySelector('cart-drawer');
    function doSectionsFetch() {
      var drawer = cartDrawer || document.querySelector('cart-drawer');
      if (!drawer) {
        if (window.theme?.refreshCart !== undefined) window.theme.refreshCart();
        window.location.href = (config.cartUrl || '/cart').toString();
        done();
        return;
      }
      var sectionsUrl = (config.sectionsUrl || window.location.pathname || '/').split('?')[0];
      if (!sectionsUrl || sectionsUrl === '') sectionsUrl = '/';
      sectionsUrl += (sectionsUrl.indexOf('?') >= 0 ? '&' : '?') + 'sections=cart-drawer,cart-icon-bubble';
      fetch(sectionsUrl, { credentials: 'same-origin' })
        .then(function (res) {
          if (res.status === 429) return {};
          return res.text().then(function (text) {
            if (typeof text === 'string' && text.trim().startsWith('<')) return {};
            try { return JSON.parse(text); } catch (e) { return {}; }
          });
        })
        .then(function (response) {
          var sections = response.sections || response;
          try {
            if (sections && typeof sections === 'object' && (sections['cart-drawer'] || sections['cart-icon-bubble'])) {
              drawer.renderContents({ sections: sections });
            } else {
              drawer.open();
            }
          } catch (e) {
            drawer.open();
          }
          done();
        })
        .catch(function () {
          drawer.open();
          done();
        });
    }
    if (cartDrawer) {
      doSectionsFetch();
    } else {
      setTimeout(doSectionsFetch, 100);
    }
  }

  function getAddToCartButton() {
    return section.querySelector('[data-bundle-add-to-cart]') || section.querySelector('button.byob__add-to-cart');
  }

  function updateAddToCartButtonState() {
    var btn = getAddToCartButton();
    if (!btn) return;
    var minItems = getMinBundleItems();
    var shouldDisable = bundle.length < minItems;
    var synced = !shouldDisable && isBundleSyncedWithCart();
    var defaultLabel = btn.getAttribute('data-byob-default-label') || 'Add to Cart';
    var openCartLabel = btn.getAttribute('data-byob-open-cart-label') || 'Open Cart';
    var textEl = btn.querySelector('[data-byob-btn-text]');

    btn.disabled = shouldDisable;
    btn.dataset.byobMode = synced ? 'open-cart' : 'add';
    if (shouldDisable) {
      btn.setAttribute('disabled', '');
      btn.setAttribute('aria-disabled', 'true');
      btn.classList.add('byob__add-to-cart--disabled');
    } else {
      btn.removeAttribute('disabled');
      btn.removeAttribute('aria-disabled');
      btn.classList.remove('byob__add-to-cart--disabled');
    }

    if (!btn.classList.contains('byob__add-to-cart--loading') && textEl) {
      textEl.textContent = synced ? openCartLabel : defaultLabel;
    }
  }

  function setAddToCartLoading(loading) {
    var btn = getAddToCartButton();
    if (!btn) return;
    var textEl = btn.querySelector('[data-byob-btn-text]');
    if (loading) {
      btn.classList.add('byob__add-to-cart--loading');
      if (textEl) textEl.textContent = 'Adding…';
    } else {
      btn.classList.remove('byob__add-to-cart--loading');
      updateAddToCartButtonState();
    }
  }

  const pills = section.querySelectorAll('.byob__pill');
  const grid = section.querySelector('[data-byob-grid]');
  const gridItems = section.querySelectorAll('.byob__grid-item');
  const listEl = section.querySelector('[data-bundle-list]');
  const emptyEl = section.querySelector('[data-bundle-empty]');
  const summaryEl = section.querySelector('[data-bundle-summary]');
  const discountBanner = section.querySelector('[data-discount-banner]');
  const discountRow = section.querySelector('[data-discount-row]');
  const gstRow = section.querySelector('[data-gst-row]');
  const savedRow = section.querySelector('[data-saved-row]');
  const subtotalEl = section.querySelector('[data-subtotal]');
  const totalEl = section.querySelector('[data-total]');
  const discountLabelEl = section.querySelector('[data-discount-label]');
  const discountAmountEl = section.querySelector('[data-discount-amount]');
  const gstAmountEl = section.querySelector('[data-gst-amount]');
  const savedAmountEl = section.querySelector('[data-saved-amount]');
  const GST_RATE = 15;
  const addToCartBtn = getAddToCartButton();
  const searchInput = section.querySelector('[data-byob-search]');
  const filterType = section.querySelector('[data-byob-filter-type]');
  const sortSelect = section.querySelector('[data-byob-sort]');

  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    if (typeof config.moneyFormat === 'string' && !config.moneyFormat.includes('{{')) {
      return config.moneyFormat.replace('{{amount}}', amount).replace('{{amount_no_decimals}}', Math.round(cents / 100));
    }
    return '$' + amount;
  }

  function getDiscountPercent() {
    const n = bundle.length;
    let discount = 0;
    bundleTiers.forEach(function (tier) {
      if (tier.exact) {
        if (n === tier.min) discount = tier.discount;
      } else {
        if (n >= tier.min && n <= tier.max) discount = tier.discount;
      }
    });
    return discount;
  }

  function getMinBundleItems() {
    if (!bundleTiers.length) return 3;
    return Math.min.apply(null, bundleTiers.map(function (t) { return t.min; }));
  }

  /** Number of slot containers to show based on the currently selected tier (size pill). */
  function getCurrentTierSlotCount() {
    var activePill = section.querySelector('.byob__pill.byob__pill--active');
    if (!activePill) {
      var firstPill = section.querySelector('.byob__pill');
      return firstPill ? Math.max(1, parseInt(firstPill.getAttribute('data-tier-min'), 10) || 3) : getMinBundleItems();
    }
    var min = parseInt(activePill.getAttribute('data-tier-min'), 10);
    return Math.max(1, isNaN(min) ? getMinBundleItems() : min);
  }

  function canAddToCart() {
    const minItems = getMinBundleItems();
    return bundle.length >= minItems;
  }

  /** Map item count to bar fill %, aligning the fill tip with each tier's milestone arrow. */
  function getProgressFillPercent(n, tiers) {
    if (window.BYOBProgressBar) {
      return window.BYOBProgressBar.getProgressFillPercent(n, tiers);
    }
    if (!tiers.length || n <= 0) return 0;

    var thresholds = tiers.map(function (t) { return Math.max(1, t.min); });
    var tierCount = tiers.length;

    function markerPosition(index) {
      return ((index + 1) / tierCount) * 100;
    }

    var firstThreshold = thresholds[0];
    if (n <= firstThreshold) {
      return (n / firstThreshold) * markerPosition(0);
    }

    for (var i = 0; i < tierCount - 1; i++) {
      var currentThreshold = thresholds[i];
      var nextThreshold = thresholds[i + 1];
      if (n <= nextThreshold) {
        var ratio = (n - currentThreshold) / (nextThreshold - currentThreshold);
        return markerPosition(i) + ratio * (markerPosition(i + 1) - markerPosition(i));
      }
    }

    return markerPosition(tierCount - 1);
  }

  /** BYOBProgress: listens for byob:changed and rerenders bar with partial progress and tier labels */
  var BYOBProgress = {
    sectionId: config.sectionId,
    tiers: bundleTiers,
    init: function () {
      var self = this;
      document.addEventListener('byob:changed', function (e) {
        var n = e.detail && typeof e.detail.selectedCount === 'number' ? e.detail.selectedCount : (window.BYOB_STATE && window.BYOB_STATE.selectedCount) || 0;
        self.render(n);
      });
      this.render(window.BYOB_STATE.selectedCount);
    },
    render: function (selectedCount) {
      var n = Math.max(0, selectedCount);
      var tiers = this.tiers.length ? this.tiers : [{ min: 3, max: 5, discount: 5 }, { min: 6, max: 8, discount: 10 }, { min: 9, max: 999, discount: 15 }];

      var sectionEl = document.getElementById('build-your-bundle-' + (this.sectionId || ''));
      if (!sectionEl) return;
      var wrap = sectionEl.querySelector('[data-byob-progress-wrap]');
      if (!wrap) return;

      if (window.BYOBProgressBar) {
        window.BYOBProgressBar.render(wrap, n, tiers);
        return;
      }

      var fillPercent = getProgressFillPercent(n, tiers);
      var firstThreshold = tiers.length ? Math.max(1, tiers[0].min) : 3;
      if (n > 0 && n < firstThreshold && fillPercent < 10) fillPercent = 10;

      var progressBar = sectionEl.querySelector('[data-byob-progress]');
      var progressFill = sectionEl.querySelector('[data-byob-progress-fill]');
      var segmentsEl = sectionEl.querySelector('[data-byob-progress-segments]');
      if (!progressBar || !progressFill) return;

      progressBar.setAttribute('data-byob-items', String(n));
      var pct = fillPercent.toFixed(2) + '%';
      progressFill.setAttribute('data-fill-pct', pct);
      progressFill.style.setProperty('width', pct, 'important');
      progressFill.style.setProperty('min-width', n > 0 ? '8px' : '0', 'important');

      if (segmentsEl) {
        segmentsEl.innerHTML = '';
        tiers.forEach(function (tier) {
          var exact = tier.exact === true;
          var achieved = exact ? (n === tier.min) : (n >= tier.min);
          var itemsDisplay = exact ? String(tier.min) : (tier.max >= 999 ? tier.min + '+' : String(tier.min));
          var seg = document.createElement('div');
          seg.className = 'byob__progress-segment' + (achieved ? ' is-achieved' : '');
          seg.setAttribute('data-tier-min', tier.min);
          seg.innerHTML = '<span class="byob__progress-segment-arrow" aria-hidden="true"></span>' +
            '<div class="byob__progress-segment-lines">' +
            '<span class="byob__progress-segment-items">' + itemsDisplay + ' items</span>' +
            '<span class="byob__progress-segment-discount">' + tier.discount + '% off</span>' +
            '</div>';
          segmentsEl.appendChild(seg);
        });
      }
    }
  };

  function updatePills() {
    const n = bundle.length;
    if (n === 0) {
      pills.forEach(function (pill, index) {
        pill.classList.toggle('byob__pill--active', index === 0);
      });
      return;
    }
    pills.forEach(function (pill, index) {
      const min = parseInt(pill.getAttribute('data-tier-min'), 10);
      const max = parseInt(pill.getAttribute('data-tier-max'), 10);
      const exact = pill.getAttribute('data-tier-exact') === 'true';
      const inRange = exact ? (n === min) : (n >= min && n <= max);
      if (inRange) {
        pill.classList.add('byob__pill--active');
        currentTierIndex = index;
      } else {
        pill.classList.remove('byob__pill--active');
      }
    });
  }

  function getCardData(card) {
    const select = card.querySelector('.byob-variant-select');
    const variantId = select ? (select.tagName === 'SELECT' ? select.options[select.selectedIndex]?.value : select.value) : card.getAttribute('data-variant-id');
    const option = select && select.tagName === 'SELECT' ? select.options[select.selectedIndex] : select;
    const price = option ? parseInt(option.getAttribute('data-price'), 10) : parseInt(card.getAttribute('data-price'), 10);
    const variantTitle = option ? option.getAttribute('data-variant-title') || '' : card.getAttribute('data-variant-title') || '';
    const imageUrl = option
      ? option.getAttribute('data-image-url') || card.getAttribute('data-image-url')
      : card.getAttribute('data-image-url');
    const cardImageUrl = option
      ? option.getAttribute('data-card-image-url') || option.getAttribute('data-image-url') || card.getAttribute('data-card-image-url')
      : card.getAttribute('data-card-image-url');
    return {
      variantId,
      productId: card.getAttribute('data-product-id'),
      price,
      title: card.getAttribute('data-title'),
      imageUrl,
      cardImageUrl,
      variantTitle,
      requiresLoa: card.getAttribute('data-requires-loa') === 'true',
      isRegularPrice: card.getAttribute('data-regular-price') === 'true'
    };
  }

  function syncCardFromData(card, data) {
    card.setAttribute('data-variant-id', data.variantId);
    card.setAttribute('data-price', data.price);
    card.setAttribute('data-variant-title', data.variantTitle || '');
    if (data.imageUrl) card.setAttribute('data-image-url', data.imageUrl);
    if (data.cardImageUrl) {
      card.setAttribute('data-card-image-url', data.cardImageUrl);
      const img = card.querySelector('.byob-card__image');
      if (img) img.src = data.cardImageUrl;
    }
    const addText = card.querySelector('.byob-add-btn__text[data-add-text]');
    if (addText) addText.textContent = 'Add - ' + formatMoney(data.price);
  }

  function isCardVariantAvailable(card) {
    var select = card.querySelector('.byob-variant-select');
    if (!select || select.tagName !== 'SELECT') return true;
    var option = select.options[select.selectedIndex];
    return !!(option && !option.disabled);
  }

  function setAddBtnLoading(card, loading) {
    var btn = card.querySelector('.byob-add-btn');
    if (!btn) return;
    if (loading) {
      btn.classList.add('byob-add-btn--loading');
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
    } else {
      btn.classList.remove('byob-add-btn--loading');
      btn.removeAttribute('aria-busy');
      btn.disabled = !isCardVariantAvailable(card);
    }
  }

  function addToBundle(card) {
    var data = getCardData(card);
    if (!data.variantId) return;
    var btn = card.querySelector('.byob-add-btn');
    if (btn && btn.classList.contains('byob-add-btn--loading')) return;

    var doAdd = function () {
      setAddBtnLoading(card, true);
      invalidateCartSync();
      window.setTimeout(function () {
        bundle.push(data);
        card.classList.remove('is-in-bundle');
        saveBundleToStorage();
        syncByobStateAndEmit();
        renderBundle();
        setAddBtnLoading(card, false);
      }, 250);
    };

    var requiresLoa = !!(data.requiresLoa || (card && card.getAttribute('data-requires-loa') === 'true'));
    var isRegularPrice = !!(data.isRegularPrice || (card && card.getAttribute('data-regular-price') === 'true'));

    var afterLoa = function () {
      if (isRegularPrice && window.RegularPriceGate && typeof window.RegularPriceGate.confirmIfNeeded === 'function') {
        window.RegularPriceGate.confirmIfNeeded(true).then(function (confirmed) {
          if (confirmed) doAdd();
        });
        return;
      }
      doAdd();
    };

    if (requiresLoa && window.LoaGate && typeof window.LoaGate.confirmIfNeeded === 'function') {
      window.LoaGate.confirmIfNeeded(true).then(function (confirmed) {
        if (confirmed) afterLoa();
      });
      return;
    }

    afterLoa();
  }

  function groupBundleItems(bundleItems) {
    var groups = [];
    var indexByVariant = {};
    bundleItems.forEach(function (item) {
      var key = String(item.variantId);
      if (indexByVariant[key] !== undefined) {
        groups[indexByVariant[key]].quantity += 1;
      } else {
        indexByVariant[key] = groups.length;
        groups.push({ item: item, quantity: 1 });
      }
    });
    return groups;
  }

  function getSectionsUrl() {
    var sectionsUrl = (config.sectionsUrl || window.location.pathname || '/').split('?')[0];
    if (!sectionsUrl || sectionsUrl === '') sectionsUrl = '/';
    return sectionsUrl + (sectionsUrl.indexOf('?') >= 0 ? '&' : '?') + 'sections=cart-drawer,cart-icon-bubble';
  }

  function notifyCartChanged(shouldOpenDrawer) {
    refreshCartDrawer(!!shouldOpenDrawer);
    try {
      if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'byob', cartData: null });
      }
    } catch (e) {}
  }

  function fetchCartJson() {
    var cartUrl = (config.cartUrl || '/cart').toString().replace(/\/$/, '');
    if (cartUrl.indexOf('.js') === -1) cartUrl = cartUrl + '.js';
    return fetch(cartUrl, { method: 'GET', headers: { 'Accept': 'application/json' } })
      .then(function (res) {
        if (!res.ok || res.status === 429) return null;
        return res.json().catch(function () { return null; });
      });
  }

  function tierCodeForItemCount(count) {
    var code = '';
    bundleTiers.forEach(function (tier) {
      if (!tier || !tier.code) return;
      var inRange = tier.exact ? count === tier.min : count >= tier.min && count <= tier.max;
      if (inRange) code = String(tier.code).trim();
    });
    return code;
  }

  function bundleItemCountFromCart(cart) {
    var count = 0;
    if (!cart || !cart.items) return 0;
    cart.items.forEach(function (item) {
      if (isBundleCartLine(item)) count += item.quantity || 0;
    });
    return count;
  }

  function allocatedDiscountCents(cart) {
    var amount = asCents(cart && cart.total_discount);
    if (amount > 0) return amount;
    ((cart && cart.cart_level_discount_applications) || []).forEach(function (app) {
      amount += asCents(app && app.total_allocated_amount);
    });
    if (amount > 0) return amount;
    ((cart && cart.items) || []).forEach(function (item) {
      if (!isBundleCartLine(item)) return;
      (item.line_level_discount_allocations || []).forEach(function (alloc) {
        amount += asCents(alloc && alloc.amount);
      });
    });
    return amount;
  }

  function cartHasAllocatedDiscount(cart, code) {
    if (!cart) return false;
    var wanted = String(code || '').trim().toLowerCase();
    if (!wanted) return false;
    var matched = false;
    var rejected = false;
    (cart.discount_codes || []).forEach(function (entry) {
      var entryCode = String((entry && entry.code) || '').trim().toLowerCase();
      if (entryCode !== wanted) return;
      matched = true;
      if (entry.applicable === false) rejected = true;
    });
    if (!matched || rejected) return false;
    return allocatedDiscountCents(cart) > 0;
  }

  function applyBundleDiscountCode(code) {
    var updateUrl = (config.cartUpdateUrl || '/cart/update.js');
    return fetch(updateUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: code })
    })
      .then(function (res) {
        return res.text().then(function (text) {
          return { status: res.status, text: text };
        });
      })
      .then(function (result) {
        var updateData = {};
        try {
          updateData = result.text && result.text.trim() && result.text.trim().charAt(0) !== '<' ? JSON.parse(result.text) : {};
        } catch (e) {
          return { ok: false, cart: null };
        }
        var cart = updateData && updateData.items ? updateData : null;
        return { ok: result.status === 200 && cartHasAllocatedDiscount(cart, code), cart: cart };
      })
      .catch(function () {
        return { ok: false, cart: null };
      });
  }

  function ensureBundleDiscount(cart) {
    var count = bundleItemCountFromCart(cart);
    var code = tierCodeForItemCount(count);
    if (!code) return Promise.resolve(cart);
    if (cartHasAllocatedDiscount(cart, code)) return Promise.resolve(cart);
    return applyBundleDiscountCode(code).then(function (result) {
      return (result && result.cart) || cart;
    });
  }

  function refreshCartDrawer(shouldOpen) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return Promise.resolve();
    return fetch(getSectionsUrl(), { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok || res.status === 429) return null;
        return res.text();
      })
      .then(function (text) {
        if (typeof text !== 'string' || !text.trim()) return;
        try {
          var data = JSON.parse(text);
          var sections = data.sections || data;
          if (!sections || (!sections['cart-drawer'] && !sections['cart-icon-bubble'])) return;
          if (typeof drawer.refreshSections === 'function') {
            drawer.refreshSections(sections, { open: shouldOpen === true });
          } else if (shouldOpen && typeof drawer.renderContents === 'function') {
            drawer.renderContents({ sections: sections });
          }
        } catch (e) {}
      })
      .catch(function () {});
  }

  function beginCartMutation() {
    byobCartMutationPending = true;
  }

  function endCartMutation() {
    byobCartMutationPending = false;
  }

  function isBundleCartLine(item) {
    return !!(item && item.properties && String(item.properties._bundle) === '1');
  }

  var cartMutationQueue = Promise.resolve();

  function runCartMutation(work) {
    beginCartMutation();
    var task = cartMutationQueue
      .then(function () {
        return work();
      })
      .finally(function () {
        endCartMutation();
      });
    cartMutationQueue = task.catch(function () {});
    return task;
  }

  function finishCartRemoval(notifyDrawer) {
    invalidateCartSync();
    if (bundle.length === 0) byobSidebarClearedAt = 0;
    if (notifyDrawer !== false) {
      notifyCartChanged(false);
    }
  }

  function changeCartLineQuantity(line, quantity) {
    var changeUrl = (config.cartChangeUrl || '/cart/change').toString();
    if (changeUrl.indexOf('.js') === -1) changeUrl = changeUrl + '.js';
    return fetch(changeUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    });
  }

  /** Remove any leftover bundle lines in cart (best-effort; never restores sidebar state). */
  function cleanupRemainingBundleLines() {
    return fetchCartJson().then(function (cart) {
      if (!cart || !cart.items || !cart.items.length) return;
      var updates = {};
      cart.items.forEach(function (item, index) {
        if (isBundleCartLine(item)) updates[String(index + 1)] = 0;
      });
      if (!Object.keys(updates).length) return;
      var updateUrl = (config.cartUpdateUrl || '/cart/update.js').toString();
      return fetch(updateUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates })
      });
    });
  }

  function findBundleLineForVariant(cart, variantId) {
    if (!cart || !cart.items || !cart.items.length) return null;
    var lineToRemove = null;
    cart.items.forEach(function (item, index) {
      if (lineToRemove != null) return;
      if (String(item.variant_id) === String(variantId) && isBundleCartLine(item)) {
        lineToRemove = index + 1;
      }
    });
    return lineToRemove;
  }

  function removeFromBundle(variantId) {
    var previousBundle = bundle.slice();
    var removeIndex = bundle.findIndex(function (item) {
      return String(item.variantId) === String(variantId);
    });
    if (removeIndex === -1) return;

    invalidateCartSync();
    bundle.splice(removeIndex, 1);
    saveBundleToStorage();
    syncByobStateAndEmit();
    syncCardsInBundle();
    renderBundle();
    if (bundle.length === 0) byobSidebarClearedAt = Date.now();
    removeVariantFromCart(variantId, previousBundle);
  }

  function removeVariantFromCart(variantId, previousBundle) {
    function restoreBundle() {
      if (!previousBundle || !previousBundle.length) return;
      byobSidebarClearedAt = 0;
      bundle = previousBundle;
      saveBundleToStorage();
      syncByobStateAndEmit();
      syncCardsInBundle();
      renderBundle();
    }

    runCartMutation(function () {
      return fetchCartJson()
        .then(function (cart) {
          var lineToRemove = findBundleLineForVariant(cart, variantId);
          if (lineToRemove == null) {
            if (bundle.length === 0) {
              return cleanupRemainingBundleLines().then(function () {
                return { ok: true };
              });
            }
            return { ok: true, skipped: true };
          }
          return changeCartLineQuantity(lineToRemove, 0).then(function (res) {
            if (!res.ok || res.status === 429 || res.status === 409) {
              return { ok: false };
            }
            if (bundle.length === 0) {
              return cleanupRemainingBundleLines().then(function () {
                return { ok: true };
              });
            }
            return { ok: true };
          });
        })
        .then(function (result) {
          if (!result || !result.ok) {
            restoreBundle();
            return;
          }
          finishCartRemoval();
        })
        .catch(function () {
          restoreBundle();
        });
    });
  }

  function syncBundleFromCart(onlyIfCartHasBundle) {
    if (byobCartMutationPending) return;
    var cartUrl = (config.cartUrl || '/cart').toString().replace(/\/$/, '');
    if (cartUrl.indexOf('.js') === -1) cartUrl = cartUrl + '.js';
    fetch(cartUrl, { method: 'GET', headers: { 'Accept': 'application/json' } })
      .then(function (res) {
        if (!res.ok || res.status === 429) return null;
        return res.json().catch(function () { return null; });
      })
      .then(function (cart) {
        if (!cart || !cart.items) return;
        var fromCart = [];
        cart.items.forEach(function (item) {
          if (isBundleCartLine(item)) {
            var img = item.image || (item.featured_image && item.featured_image.url) || '';
            var unitPrice = item.original_price != null ? item.original_price : item.price;
            for (var q = 0; q < (item.quantity || 1); q++) {
              fromCart.push({
                variantId: item.variant_id,
                productId: item.product_id,
                price: unitPrice,
                title: item.title,
                imageUrl: img,
                variantTitle: (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '',
                requiresLoa: productRequiresLoa(item.product_id),
                isRegularPrice: !!(item.properties && String(item.properties._bundle_regular) === '1') || productIsRegularPrice(item.product_id)
              });
            }
          }
        });
        if (onlyIfCartHasBundle && fromCart.length === 0) return;
        if (
          bundle.length === 0 &&
          fromCart.length > 0 &&
          byobSidebarClearedAt &&
          Date.now() - byobSidebarClearedAt < 3000
        ) {
          return;
        }
        bundle = fromCart;
        saveBundleToStorage();
        syncByobStateAndEmit();
        syncCardsInBundle();
        markBundleSyncedWithCart();
        renderBundle(fromCart.length ? cart : null);
        updateAddToCartButtonState();
      })
      .catch(function () {});
  }

  function syncCardsInBundle() {
    section.querySelectorAll('.byob-card').forEach(function (card) {
      card.classList.remove('is-in-bundle');
    });
  }

  /* Bumped on every summary render so a slower /cart.js response cannot overwrite a newer one. */
  var summaryRequestId = 0;
  var discountLabelParent = null;
  var discountLabelPrefix = 'Bundle Discount';
  var discountBannerTextParent = null;
  var discountAppliedSuffix = '% discount applied';

  function asCents(value) {
    var n = Number(value);
    if (!isFinite(n)) return 0;
    return Math.trunc(n);
  }

  /* Half-up integer division. Matches snippets/cart-gst-cents.liquid (plus half the divisor, then truncate). */
  function roundHalfUpDiv(numerator, denominator) {
    var n = Math.trunc(Number(numerator));
    var d = Math.trunc(Number(denominator));
    if (!isFinite(n) || !isFinite(d) || d === 0) return 0;
    var sign = n < 0 ? -1 : 1;
    var abs = Math.abs(n);
    return sign * Math.floor((abs + Math.floor(d / 2)) / d);
  }

  function formatDiscountPercent(value) {
    var n = Number(value);
    if (!isFinite(n)) return '';
    var rounded = Math.round(n * 100) / 100;
    if (Math.abs(rounded - Math.round(rounded)) < 0.001) return String(Math.round(rounded));
    return String(rounded);
  }

  function readPercentageApplications(apps) {
    var percent = null;
    var consistent = true;
    var saw = false;
    var title = '';
    (apps || []).forEach(function (app) {
      if (!app) return;
      if (!title && app.title) title = String(app.title);
      if (String(app.value_type || '').toLowerCase() === 'percentage' && app.value != null && app.value !== '') {
        var p = parseFloat(app.value);
        if (!saw) {
          percent = p;
          saw = true;
        } else if (Math.abs(percent - p) > 0.001) {
          consistent = false;
        }
      } else {
        consistent = false;
      }
    });
    return { percent: saw && consistent ? percent : null, title: title };
  }

  function readCartLevelDiscount(cart) {
    var apps = (cart && cart.cart_level_discount_applications) || [];
    var amount = 0;
    apps.forEach(function (app) {
      amount += asCents(app && app.total_allocated_amount);
    });
    var meta = readPercentageApplications(apps);
    return { amount: amount, percent: meta.percent, title: meta.title };
  }

  function readBundleLineDiscount(cart) {
    var amount = 0;
    var apps = [];
    (cart.items || []).forEach(function (item) {
      if (!isBundleCartLine(item)) return;
      var original = asCents(item.original_line_price);
      var finalPrice = item.final_line_price == null ? original : asCents(item.final_line_price);
      amount += original - finalPrice;
      (item.line_level_discount_allocations || []).forEach(function (alloc) {
        if (alloc && alloc.discount_application) apps.push(alloc.discount_application);
      });
    });
    var meta = readPercentageApplications(apps);
    return { amount: amount, percent: meta.percent, title: meta.title };
  }

  function bundlePriceParts(cart) {
    var subtotal = 0;
    var eligible = 0;
    (cart.items || []).forEach(function (item) {
      if (!isBundleCartLine(item)) return;
      var original = asCents(item.original_line_price);
      subtotal += original;
      var regular = item.properties && String(item.properties._bundle_regular) === '1';
      if (!regular) eligible += original;
    });
    return { subtotal: subtotal, eligible: eligible };
  }

  function buildCartSummary(cart) {
    var parts = bundlePriceParts(cart);
    var cartLevel = (cart.cart_level_discount_applications || []).length > 0;
    var discount = cartLevel ? readCartLevelDiscount(cart) : readBundleLineDiscount(cart);
    if (!(discount.amount > 0)) {
      discount.amount = 0;
      discount.percent = null;
    }
    var subtotal = parts.subtotal;
    var net = asCents(cart.total_price);
    if (net < 0) net = 0;
    var gstAmount;
    var total;
    if (cart.taxes_included) {
      gstAmount = roundHalfUpDiv(net * GST_RATE, 115);
      total = net;
    } else {
      gstAmount = roundHalfUpDiv(net * GST_RATE, 100);
      total = net + gstAmount;
    }
    return {
      subtotal: subtotal,
      discountAmount: discount.amount,
      discountPercent: discount.percent,
      discountTitle: discount.title,
      gstAmount: gstAmount,
      total: total
    };
  }

  function buildEstimateSummary() {
    var discountPercent = getDiscountPercent();
    var eligibleSubtotal = 0;
    var regularSubtotal = 0;
    bundle.forEach(function (item) {
      if (item && item.isRegularPrice) regularSubtotal += item.price;
      else eligibleSubtotal += item.price;
    });
    var subtotal = eligibleSubtotal + regularSubtotal;
    var discountAmount = roundHalfUpDiv(eligibleSubtotal * discountPercent, 100);
    var productsTotal = subtotal - discountAmount;
    var gstAmount = roundHalfUpDiv(productsTotal * GST_RATE, 100);
    return {
      subtotal: subtotal,
      discountAmount: discountAmount,
      discountPercent: discountPercent > 0 && discountAmount > 0 ? discountPercent : null,
      discountTitle: '',
      gstAmount: gstAmount,
      total: productsTotal + gstAmount
    };
  }

  function ensureSummaryLabelNodes() {
    if (!discountLabelParent && discountLabelEl) {
      discountLabelParent = discountLabelEl.parentElement;
      if (discountLabelParent) {
        var text = discountLabelParent.textContent || '';
        var paren = text.indexOf('(');
        var prefix = (paren >= 0 ? text.slice(0, paren) : text).replace(/\s+/g, ' ').trim();
        if (prefix) discountLabelPrefix = prefix;
      }
    }
    if (!discountBannerTextParent && discountBanner) {
      var percentEl = discountBanner.querySelector('[data-discount-percent]');
      discountBannerTextParent = percentEl ? percentEl.parentElement : null;
      if (discountBannerTextParent) {
        var bannerText = discountBannerTextParent.textContent || '';
        var pct = bannerText.indexOf('%');
        if (pct >= 0) discountAppliedSuffix = bannerText.slice(pct);
      }
    }
  }

  function writeDiscountLabel(summary) {
    ensureSummaryLabelNodes();
    if (!discountLabelParent) return;
    if (summary.discountPercent != null && summary.discountPercent > 0) {
      discountLabelParent.textContent = discountLabelPrefix + ' (' + formatDiscountPercent(summary.discountPercent) + '%)';
    } else if (summary.discountTitle) {
      discountLabelParent.textContent = summary.discountTitle;
    } else {
      discountLabelParent.textContent = discountLabelPrefix;
    }
  }

  function writeDiscountBanner(summary) {
    ensureSummaryLabelNodes();
    if (!discountBanner) return;
    if (!(summary.discountAmount > 0)) {
      discountBanner.classList.add('hidden');
      return;
    }
    if (summary.discountPercent != null && summary.discountPercent > 0 && discountBannerTextParent) {
      discountBanner.classList.remove('hidden');
      discountBannerTextParent.textContent = formatDiscountPercent(summary.discountPercent) + discountAppliedSuffix;
      return;
    }
    if (summary.discountTitle && discountBannerTextParent) {
      discountBanner.classList.remove('hidden');
      discountBannerTextParent.textContent = summary.discountTitle;
      return;
    }
    discountBanner.classList.add('hidden');
  }

  function paintSummary(summary) {
    if (subtotalEl) subtotalEl.textContent = formatMoney(summary.subtotal);
    if (totalEl) totalEl.textContent = formatMoney(summary.total);
    if (discountRow) {
      if (summary.discountAmount > 0) {
        discountRow.classList.remove('hidden');
        writeDiscountLabel(summary);
        if (discountAmountEl) discountAmountEl.textContent = '-' + formatMoney(summary.discountAmount);
      } else {
        discountRow.classList.add('hidden');
      }
    }
    writeDiscountBanner(summary);
    if (gstRow) {
      if (summary.gstAmount > 0) {
        gstRow.classList.remove('hidden');
        if (gstAmountEl) gstAmountEl.textContent = '+' + formatMoney(summary.gstAmount);
      } else {
        gstRow.classList.add('hidden');
      }
    }
    if (savedRow) {
      if (summary.discountAmount > 0) {
        savedRow.classList.remove('hidden');
        if (savedAmountEl) savedAmountEl.textContent = formatMoney(summary.discountAmount);
      } else {
        savedRow.classList.add('hidden');
      }
    }
  }

  function renderBundle(cartSnapshot) {
    summaryRequestId += 1;
    var requestId = summaryRequestId;
    /* Sync active pill with current item count (e.g. 6 items → 6–8 tier active) */
    updatePills();

    var slotsContainer = emptyEl ? emptyEl.querySelector('[data-bundle-slots]') : null;
    var tierSlots = getCurrentTierSlotCount();
    /* Show at least as many slots as selected tier; if user added more items, add slots and follow next tier */
    var N = Math.max(tierSlots, bundle.length);

    if (listEl) listEl.classList.add('byob__bundle-list--slots-mode');
    if (emptyEl) emptyEl.classList.remove('hidden');

    if (bundle.length === 0) {
      summaryEl.classList.add('hidden');
      if (discountBanner) discountBanner.classList.add('hidden');
      if (slotsContainer) renderSlots(slotsContainer, N, []);
      updateAddToCartButtonState();
      return;
    }

    summaryEl.classList.remove('hidden');
    if (slotsContainer) renderSlots(slotsContainer, N, bundle);

    if (cartSnapshot && cartSnapshot.items) {
      paintSummary(buildCartSummary(cartSnapshot));
    } else if (isBundleSyncedWithCart()) {
      fetchCartJson().then(function (cart) {
        if (requestId !== summaryRequestId) return;
        if (!cart || !cart.items || !isBundleSyncedWithCart()) return;
        paintSummary(buildCartSummary(cart));
      });
    } else {
      paintSummary(buildEstimateSummary());
    }
    updateAddToCartButtonState();
    syncCardsInBundle();
  }

  function getBundleSectionLabels() {
    var t = (typeof window.buildYourBundle !== 'undefined' && window.buildYourBundle.translations) || {};
    return {
      discounted: t.section_discounted || 'Build Your Own Bundle',
      regular: t.section_regular || 'Regular Prices',
      emptySlot: t.empty_slot || 'Add product'
    };
  }

  function appendSlotHeading(container, label, modifierClass) {
    var heading = document.createElement('p');
    heading.className = 'byob__bundle-section-title' + (modifierClass ? ' ' + modifierClass : '');
    heading.textContent = label;
    container.appendChild(heading);
  }

  function appendFilledSlot(container, group, slotIndex) {
    var item = group.item;
    var slot = document.createElement('div');
    slot.className = 'byob__bundle-slot byob__bundle-slot--filled';
    slot.setAttribute('data-slot-index', slotIndex);
    if (item.isRegularPrice) slot.classList.add('byob__bundle-slot--regular');
    var qtyBadge = group.quantity >= 1
      ? '<span class="byob__bundle-slot-qty" aria-label="Quantity: ' + group.quantity + '">' + group.quantity + '</span>'
      : '';
    var lineTotal = item.price * group.quantity;
    slot.innerHTML =
      '<div class="byob__bundle-item-media">' +
        '<img class="byob__bundle-item-image" src="' + (item.imageUrl || '') + '" alt="" loading="lazy" width="50" height="50">' +
        qtyBadge +
      '</div>' +
      '<div class="byob__bundle-item-info">' +
        '<p class="byob__bundle-item-title">' + (item.variantTitle && item.variantTitle.toLowerCase() !== 'default title' ? item.title + ' (' + item.variantTitle + ')' : item.title) + '</p>' +
        '<span class="byob__bundle-item-price">' + formatMoney(lineTotal) + '</span>' +
      '</div>' +
      '<button type="button" class="byob__bundle-item-remove" data-remove-variant="' + item.variantId + '" aria-label="Remove">' +
        BYOB_REMOVE_ICON_HTML +
      '</button>';
    container.appendChild(slot);
  }

  function renderSlots(container, slotCount, bundleItems) {
    if (!container) return;
    container.innerHTML = '';
    var labels = getBundleSectionLabels();
    var emptyLabel = labels.emptySlot;
    var discountedItems = [];
    var regularItems = [];
    bundleItems.forEach(function (item) {
      if (item && item.isRegularPrice) regularItems.push(item);
      else discountedItems.push(item);
    });
    var emptyCount = Math.max(0, slotCount - bundleItems.length);
    var hasRegular = regularItems.length > 0;
    var slotIndex = 0;

    /* Discounted-only: keep existing flat slot UI (no section headings). */
    if (!hasRegular) {
      var groups = groupBundleItems(discountedItems);
      groups.forEach(function (group) {
        appendFilledSlot(container, group, slotIndex);
        slotIndex += 1;
      });
      for (var e = 0; e < emptyCount; e++) {
        var emptySlot = document.createElement('div');
        emptySlot.className = 'byob__bundle-slot byob__bundle-slot--empty';
        emptySlot.setAttribute('data-slot-index', slotIndex);
        slotIndex += 1;
        emptySlot.innerHTML = '<span class="byob__bundle-slot-placeholder" aria-hidden="true">' + emptyLabel + '</span>';
        container.appendChild(emptySlot);
      }
      return;
    }

    if (discountedItems.length > 0 || emptyCount > 0) {
      appendSlotHeading(container, labels.discounted);
      groupBundleItems(discountedItems).forEach(function (group) {
        appendFilledSlot(container, group, slotIndex);
        slotIndex += 1;
      });
      for (var i = 0; i < emptyCount; i++) {
        var empty = document.createElement('div');
        empty.className = 'byob__bundle-slot byob__bundle-slot--empty';
        empty.setAttribute('data-slot-index', slotIndex);
        slotIndex += 1;
        empty.innerHTML = '<span class="byob__bundle-slot-placeholder" aria-hidden="true">' + emptyLabel + '</span>';
        container.appendChild(empty);
      }
    }

    appendSlotHeading(container, labels.regular, 'byob__bundle-section-title--regular');
    groupBundleItems(regularItems).forEach(function (group) {
      appendFilledSlot(container, group, slotIndex);
      slotIndex += 1;
    });
  }

  function handleVariantChange(card, variantId) {
    const data = getCardData(card);
    syncCardFromData(card, data);
    setAddBtnLoading(card, false);
  }

  function closeAllVariantDropdowns(except) {
    section.querySelectorAll('[data-byob-variant-dropdown].is-open').forEach(function (dropdown) {
      if (except && dropdown === except) return;
      var list = dropdown.querySelector('.byob-variant-dropdown__list');
      var trigger = dropdown.querySelector('.byob-variant-dropdown__trigger');
      if (list) list.hidden = true;
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      dropdown.classList.remove('is-open');
    });
  }

  function initVariantDropdowns(root) {
    (root || section).querySelectorAll('[data-byob-variant-dropdown]').forEach(function (dropdown) {
      if (dropdown.dataset.initialized === '1') return;
      dropdown.dataset.initialized = '1';

      var trigger = dropdown.querySelector('.byob-variant-dropdown__trigger');
      var list = dropdown.querySelector('.byob-variant-dropdown__list');
      var valueEl = dropdown.querySelector('.byob-variant-dropdown__value');
      var select = dropdown.querySelector('.byob-variant-select');
      var card = dropdown.closest('.byob-card');
      if (!trigger || !list || !select || !card) return;

      function closeDropdown() {
        list.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
        dropdown.classList.remove('is-open');
      }

      function openDropdown() {
        closeAllVariantDropdowns(dropdown);
        list.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
        dropdown.classList.add('is-open');
      }

      function selectOption(option) {
        if (option.classList.contains('is-disabled')) return;
        var variantId = option.getAttribute('data-variant-id');
        select.value = variantId;
        list.querySelectorAll('.byob-variant-dropdown__option').forEach(function (opt) {
          var isSelected = opt === option;
          opt.classList.toggle('is-selected', isSelected);
          opt.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        });
        if (valueEl) valueEl.textContent = option.textContent.trim();
        closeDropdown();
        handleVariantChange(card, variantId);
      }

      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (dropdown.classList.contains('is-open')) closeDropdown();
        else openDropdown();
      });

      list.querySelectorAll('.byob-variant-dropdown__option:not(.is-disabled)').forEach(function (option) {
        option.setAttribute('tabindex', '0');
        option.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          selectOption(option);
        });
        option.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            selectOption(option);
          }
        });
      });

      dropdown.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          closeDropdown();
          trigger.focus();
        }
      });
    });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-byob-variant-dropdown]')) closeAllVariantDropdowns();
  });

  section.addEventListener('click', function (e) {
    var pill = e.target.closest('.byob__pill');
    if (pill) {
      pills.forEach(function (p, index) {
        p.classList.toggle('byob__pill--active', p === pill);
        if (p === pill) currentTierIndex = index;
      });
      renderBundle();
      return;
    }
    var addBtn = e.target.closest('.byob-add-btn[data-action="add"], .byob-add-btn[data-action="toggle"]');
    if (addBtn) {
      var card = addBtn.closest('.byob-card');
      if (card && !addBtn.disabled) {
        e.preventDefault();
        addToBundle(card);
      }
      return;
    }
    var removeBtn = e.target.closest('[data-remove-variant]');
    if (removeBtn) {
      e.preventDefault();
      removeFromBundle(removeBtn.getAttribute('data-remove-variant'));
    }
  });

  initVariantDropdowns();

  section.querySelectorAll('.byob-card').forEach(function (card) {
    var select = card.querySelector('.byob-variant-select');
    if (select && !select.closest('[data-byob-variant-dropdown]')) {
      select.addEventListener('change', function () {
        handleVariantChange(card, select.options && select.options[select.selectedIndex] ? select.options[select.selectedIndex].value : select.value);
      });
    }
  });

  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', function () {
      if (addToCartBtn.disabled) return;
      if (addToCartBtn.getAttribute('data-byob-adding') === '1') return;

      if (isBundleSyncedWithCart()) {
        openCartDrawer();
        return;
      }

      if (!canAddToCart()) return;

      var requiresLoa = bundle.some(function (item) {
        return !!(item && item.requiresLoa) || productRequiresLoa(item && item.productId);
      });
      var startAdd = function () {
      addToCartBtn.setAttribute('data-byob-adding', '1');

      var discountPercent = getDiscountPercent();
      var tierIndex = -1;
      bundleTiers.forEach(function (tier, i) {
        if (tier.exact) {
          if (bundle.length === tier.min) tierIndex = i;
        } else {
          if (bundle.length >= tier.min && bundle.length <= tier.max) tierIndex = i;
        }
      });
      var messageEl = section.querySelector('[data-byob-discount-message]');

      var baseProps = { _bundle: '1' };
      var appKey = (config.bundleAppPropertyName || '').trim();
      var appVal = (config.bundleAppPropertyValue || '').trim();
      var items = bundle.map(function (item) {
        var props = Object.assign({}, baseProps);
        if (item && item.isRegularPrice) {
          props._bundle_regular = '1';
        } else if (appKey && appVal !== undefined) {
          props[appKey] = appVal;
        }
        return { id: item.variantId, quantity: 1, properties: props };
      });
      addToCartBtn.setAttribute('aria-busy', 'true');
      addToCartBtn.disabled = true;
      setAddToCartLoading(true);
      if (messageEl) {
        messageEl.classList.add('hidden');
        messageEl.textContent = '';
      }
      var discountCodeToApply = (tierIndex >= 0 && bundleTiers[tierIndex] && bundleTiers[tierIndex].code) ? String(bundleTiers[tierIndex].code).trim() : '';
      byobLog('Add to cart started', {
        bundleItemCount: bundle.length,
        tierIndex: tierIndex,
        discountCode: discountCodeToApply || '(none – will not apply code)',
        tierRange: tierIndex >= 0 && bundleTiers[tierIndex] ? (bundleTiers[tierIndex].min + '-' + bundleTiers[tierIndex].max) : 'n/a'
      });
      fetch((config.cartAddUrl || '/cart/add.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          if (res.status === 429) {
            throw new Error('Too many requests. Please wait a moment and try again.');
          }
          return res.text();
        })
        .then(function (text) {
          if (typeof text === 'string' && text.trim().startsWith('<')) {
            throw new Error('Could not add to cart. Please try again.');
          }
          var data = JSON.parse(text);
          if (data.status && data.status !== 200) {
            throw new Error(data.description || 'Could not add to cart');
          }
          syncByobStateAndEmit();
          renderBundle();
          markBundleSyncedWithCart();
          byobLog('Cart add success');

          var discountCode = discountCodeToApply;
          var updateUrl = (config.cartUpdateUrl || '/cart/update.js');

          function refreshAndOpenDrawer(done) {
            done = typeof done === 'function' ? done : function () {};
            byobLog('Refreshing cart drawer and opening');
            openCartDrawer(function () {
              setTimeout(logCartDiscountState, 800);
              done();
            });
          }

          function applyDiscountCode(code, attempt) {
            attempt = attempt || 1;
            var signatureAtApply = getBundleSignature(bundle);
            byobLog('Applying discount code (attempt ' + attempt + ')', { code: code, url: updateUrl });
            return fetch(updateUrl, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ discount: code })
            })
              .then(function (res) {
                byobLog('Discount apply response status', res.status, res.statusText);
                return res.text().then(function (text) { return { status: res.status, text: text }; });
              })
              .then(function (result) {
                if (getBundleSignature(bundle) !== signatureAtApply) {
                  byobLog('Discount apply ignored – bundle changed before Shopify returned the cart');
                  return { ok: false, cart: null, ignored: true };
                }
                var ok = false;
                var updateData = {};
                try {
                  updateData = typeof result.text === 'string' && result.text.trim() ? JSON.parse(result.text) : {};
                  // /cart/update.js returns the cart object, not { status: 200 }. Success = HTTP 200 and cart shows discount applied.
                  var hasDiscount = cartHasAllocatedDiscount(updateData, code);
                  ok = result.status === 200 && hasDiscount;
                } catch (e) {
                  byobLog('Discount apply response parse error', e.message, 'raw:', result.text ? result.text.substring(0, 200) : '');
                  return { ok: false, cart: null, ignored: false };
                }
                byobLog('Discount apply response body', updateData);
                if (!ok && updateData.message) {
                  byobLog('Discount apply failed – Shopify message:', updateData.message);
                }
                return {
                  ok: ok,
                  cart: updateData && updateData.items ? updateData : null,
                  ignored: false
                };
              })
              .catch(function (err) {
                byobLog('Discount apply request error', err);
                return { ok: false, cart: null, ignored: false };
              });
          }

          function showSummaryFromCartResult(result) {
            if (result && result.ignored) return;
            if (result && result.cart) {
              renderBundle(result.cart);
              return;
            }
            if (isBundleSyncedWithCart()) renderBundle();
          }

          function runAfterAdd(done) {
            done = typeof done === 'function' ? done : function () {};
            if (discountCode) {
              byobLog('Will apply discount code', discountCode);
              applyDiscountCode(discountCode, 1).then(function (result) {
                byobLog('First discount apply result', result && result.ok ? 'OK' : 'FAILED');
                logCartDiscountState();
                if (!result || !result.ok) {
                  if (result && result.ignored) {
                    done();
                    return;
                  }
                  byobLog('Retrying discount code in 600ms');
                  setTimeout(function () {
                    applyDiscountCode(discountCode, 2).then(function (retry) {
                      showSummaryFromCartResult(retry);
                    }).finally(function () {
                      logCartDiscountState();
                      refreshAndOpenDrawer(done);
                    });
                  }, 600);
                } else {
                  showSummaryFromCartResult(result);
                  refreshAndOpenDrawer(done);
                }
              });
            } else {
              byobLog('No discount code configured for this tier – skipping apply');
              setTimeout(function () {
                if (isBundleSyncedWithCart()) renderBundle();
                refreshAndOpenDrawer(done);
              }, 150);
            }
          }
          var runPromise = new Promise(function (resolve) {
            setTimeout(function () { runAfterAdd(resolve); }, 250);
          });
          return runPromise;
        })
        .catch(function (err) {
          setAddToCartLoading(false);
          alert(err.message || 'Something went wrong. Please try again.');
        })
        .finally(function () {
          setAddToCartLoading(false);
          addToCartBtn.removeAttribute('data-byob-adding');
          addToCartBtn.removeAttribute('aria-busy');
          updateAddToCartButtonState();
        });
      };

      if (window.LoaGate && typeof window.LoaGate.confirmIfNeeded === 'function') {
        window.LoaGate.confirmIfNeeded(requiresLoa).then(function (confirmed) {
          if (confirmed) startAdd();
        });
      } else {
        startAdd();
      }
    });
  }

  if (searchInput) {
    searchInput.addEventListener('input', filterGrid);
  }
  if (filterType) {
    filterType.addEventListener('change', filterGrid);
  }
  if (sortSelect) {
    sortSelect.addEventListener('change', sortGrid);
  }

  function filterGrid() {
    const q = (searchInput?.value || '').toLowerCase().trim();
    const type = (filterType?.value || '').toLowerCase();
    gridItems.forEach(function (item) {
      const title = (item.getAttribute('data-product-title') || '').toLowerCase();
      const productType = (item.getAttribute('data-product-type') || '').toLowerCase();
      const show = (!q || title.indexOf(q) >= 0) && (!type || productType === type);
      item.style.display = show ? '' : 'none';
    });
  }

  function sortGrid() {
    const value = sortSelect?.value || 'manual';
    const items = Array.from(gridItems);
    if (value === 'manual') return;
    if (value === 'best-selling') return;

    function sortGroup(groupItems) {
      const cards = groupItems.map(function (item) {
        const card = item.querySelector('.byob-card');
        const price = card ? parseInt(card.getAttribute('data-price'), 10) : 0;
        const title = (card?.getAttribute('data-title') || '').toLowerCase();
        return { item, price, title };
      });
      if (value === 'price-ascending') cards.sort(function (a, b) { return a.price - b.price; });
      else if (value === 'price-descending') cards.sort(function (a, b) { return b.price - a.price; });
      else if (value === 'title-ascending') cards.sort(function (a, b) { return a.title.localeCompare(b.title); });
      return cards;
    }

    /* Keep discounted collection products before regular-price products. */
    var discounted = items.filter(function (item) {
      return item.getAttribute('data-regular-price-item') !== 'true';
    });
    var regular = items.filter(function (item) {
      return item.getAttribute('data-regular-price-item') === 'true';
    });
    sortGroup(discounted).forEach(function (o) { grid.appendChild(o.item); });
    sortGroup(regular).forEach(function (o) { grid.appendChild(o.item); });
  }

  bundle = rehydrateBundleLoaFlags(loadBundleFromStorage());
  loadCartSyncFromStorage();
  syncCardsInBundle();
  updatePills();
  renderBundle();
  syncByobStateAndEmit();
  BYOBProgress.init();
  /* Re-apply button state after a tick in case DOM or theme scripts run later */
  setTimeout(updateAddToCartButtonState, 0);
  setTimeout(updateAddToCartButtonState, 100);

  /* On load: if cart already has bundle items, show them in the sidebar (fixes empty sidebar when cart has bundle) */
  setTimeout(function () {
    syncBundleFromCart(true);
  }, 100);

  /* When cart is updated (e.g. item removed in drawer), sync sidebar bundle from cart. Skip when we triggered the update (no extra /cart.js). Debounce to avoid 429 on rapid updates. */
  var syncFromCartTimer = null;
  function debouncedSyncBundleFromCart(onlyIfCartHasBundle) {
    if (syncFromCartTimer) clearTimeout(syncFromCartTimer);
    syncFromCartTimer = setTimeout(function () {
      syncFromCartTimer = null;
      syncBundleFromCart(!!onlyIfCartHasBundle);
    }, 400);
  }
  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.source === 'byob') return;
      if (byobCartMutationPending) return;
      if (window.byobEnsureDiscountTimer) clearTimeout(window.byobEnsureDiscountTimer);
      window.byobEnsureDiscountTimer = setTimeout(function () {
        window.byobEnsureDiscountTimer = null;
        fetchCartJson().then(function (cart) {
          if (!cart) return;
          var code = tierCodeForItemCount(bundleItemCountFromCart(cart));
          var already = !!(code && cartHasAllocatedDiscount(cart, code));
          ensureBundleDiscount(cart).then(function () {
            if (code && !already) refreshCartDrawer(false);
            syncBundleFromCart(false);
          });
        });
      }, 500);
    });
  }

  var byobCheckoutSubmitting = false;
  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest ? event.target.closest('[name="checkout"]') : null;
    if (!button || byobCheckoutSubmitting) return;
    if (button.disabled) return;
    event.preventDefault();
    event.stopPropagation();
    fetchCartJson().then(function (cart) {
      return ensureBundleDiscount(cart);
    }).finally(function () {
      byobCheckoutSubmitting = true;
      button.click();
      byobCheckoutSubmitting = false;
    });
  }, true);

  document.addEventListener('byob:sync-from-cart', function (event) {
    if (byobCartMutationPending) return;
    var onlyIf = event && event.detail && event.detail.onlyIfCartHasBundle;
    debouncedSyncBundleFromCart(onlyIf);
  });

  window.BYOB_LOG_CART = function () {
    byobLog('Manual cart discount check (run before clicking Checkout):');
    logCartDiscountState();
  };
})();
